import { BusinessArea } from "../interfaces/business-area-ce.interface";
import { FilterableItem } from "../interfaces/filter.interface";

export function filterItems<T extends FilterableItem>(items: T[], filter: { search: string; businessAreas: BusinessArea[] }): T[] {
    let filteredItems = items;

    if (filter.businessAreas && filter.businessAreas.length > 0) {
        filteredItems = filteredItems.filter((item) => {
            const keyword = item.businessAreaId ?? "";
            return filter.businessAreas.some((area) => keyword.toLowerCase() === area.id.toLowerCase());
        });
    }

    if (filter.search && filter.search.length > 1) {
        filteredItems = filteredItems.filter((item) => {
            return item.name?.toLowerCase().includes(filter.search.toLowerCase()) || item.description?.toLowerCase().includes(filter.search.toLowerCase());
        });
    }

    return filteredItems;
}
